<script setup>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

import adminWechatQr from '@/apps/portal/assets/admin-wechat-qr.jpg'

const { t } = useI18n()
const visible = ref(false)
</script>

<template>
  <el-button
    class="invite-code-help-link"
    link
    type="primary"
    :aria-label="t('common.getInviteCode')"
    @click.stop="visible = true"
  >
    {{ t('common.getInviteCode') }}
  </el-button>

  <el-dialog
    v-model="visible"
    class="invite-code-help-dialog"
    :title="t('common.getInviteCode')"
    width="min(88vw, 380px)"
    append-to-body
    destroy-on-close
  >
    <div class="invite-code-help-content">
      <img :src="adminWechatQr" :alt="t('common.adminWechatQrAlt')">
      <p>{{ t('common.adminWechatInviteTip') }}</p>
    </div>
  </el-dialog>
</template>

<style scoped>
.invite-code-help-link {
  flex: none;
  padding: 0 2px;
  font-size: 13px;
  white-space: nowrap;
}

.invite-code-help-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  text-align: center;
}

.invite-code-help-content img {
  display: block;
  width: min(100%, 300px);
  height: auto;
  border-radius: 8px;
}

.invite-code-help-content p {
  margin: 0;
  color: var(--el-text-color-primary);
  font-size: 15px;
  line-height: 1.6;
}
</style>
